import requestAction from '../../utils/requestAction'

export const fetchClient = (clientId: string) =>
  requestAction('CLIENT_DETAIL')(`clients/${clientId}`, 'GET')
